import { http } from 'interfaces'
import { type OrgOption, type OrgParams } from 'components'
import { type SearchResponse } from 'services'

interface OrganizationsResponse {
  organizations: Array<{
    id: number
    organization_name: string
    country: string
    type: string
    top_level_name: string
  }>
}

async function searchServerCall (searchTerm: string): Promise<OrganizationsResponse> {
  return await http
    .get('/api/v1/autocomplete/', {
      params: { organizations: searchTerm }
    }).then(value => value.data)
}

export const searchOrgByName = async (searchTerm: string): Promise<OrgOption[]> => {
  return await searchServerCall(searchTerm)
    .then((response) => {
      return response.organizations.map((o) => ({
        title: `${o.id}: ${o.organization_name} (${o.country} - ${o.type} - ${o.top_level_name})`,
        id: o.id
      }))
    })
    .catch((reason: any) => {
      console.log(reason)
      return []
    })
}

export const searchOrganizationsByName = async (searchTerm: string, countryId: number | null, parentOrgIdsAlreadyAdded: number[] | null): Promise<OrgParams[]> => {
  return await searchParentOrganizationsByNameServerCall(searchTerm, countryId, parentOrgIdsAlreadyAdded)
    .then((response) => {
      return response.map((o) => ({
        title: `${o.id}: ${o.organization_name} `,
        id: Number(o.id),
        countryId: Number(o.countryId)
      }))
    })
    .catch((reason: any) => {
      console.log(reason)
      return []
    })
}

export const searchAllOrganizationsByName = async (searchTerm: string, countryId: number | null, parentOrgIdsAlreadyAdded: number[] | null): Promise<OrgParams[]> => {
  return await searchAllOrganizationsByNameServerCall(searchTerm, countryId, parentOrgIdsAlreadyAdded)
    .then((response) => {
      return response.map((o) => ({
        title: `${o.id} - ${o.organization_name} `,
        id: Number(o.id),
        countryId: Number(o.countryId)
      }))
    })
    .catch((reason: any) => {
      console.log(reason)
      return []
    })
}

export interface ParentOrgResponse {
  id: number
  organization_name: string
  countryId: number
}

async function searchParentOrganizationsByNameServerCall (searchTerm: string, countryId: number | null, parentOrgIdsAlreadyAdded: number[] | null): Promise<ParentOrgResponse[]> {
  countryId = countryId !== 0 ? countryId : null
  return await http
    .get('/api/v1/organizations/parent/', {
      params: { searchTerm, countryId, parentOrgIdsAlreadyAdded }
    }).then(value => value.data)
}

async function searchAllOrganizationsByNameServerCall (searchTerm: string, countryId: number | null, parentOrgIdsAlreadyAdded: number[] | null): Promise<ParentOrgResponse[]> {
  countryId = countryId !== 0 ? countryId : null
  const params = {
    organizations: searchTerm,
    country: countryId
  }
  return await http
    .get('/api/v1/autocomplete/', {
      params
    }).then(value => {
      const data: SearchResponse = value.data
      return data.organizations.map((value1) => ({ id: Number(value1.id), organization_name: value1.organization_name, countryId: value1.country.id }))
    })
    .catch(reason => [])
}
